
<div class="web-view" 
fxHide.xs fxHide.sm   fxHide.lt-md fxFlex.md > 

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>


    <div class="main-div" fxLayout="row wrap" >
         
        <div fxLayout="row">
        <div fxLayout="column wrap" class="description-div" >
            <h1 class="heading">Host Screening Parties </h1>
            <p>
                
            </p>
            <p >
                Welcome to Hosting a Screening Party—an easy and fun way to support and engage with Cinejoy movies, events, artists, and community.
            </p>          
                Requirements are as follows:           
                <div fxLayout="row wrap"  fxLayoutAlign="start center" >
                    
                    <ul  >
                        <li class="before">Utilize your Zoom Meeting account for your Screening Party.</li>
                        <li class="before">Agree to invite/engage 50% of your friends and family in your meeting while opening up the remaining spots for the Cinejoy community at large.</li>
                        <li class="before"><a href="https://www.youtube.com/watch?v=Hmvr3fD2auI" target="_blank">Watch the Host training video.</a></li>
                        <li class="before"><a href="/cinejoy/screening-parties/host-guide">How-to Host guide.</a></li>
                        
                        <li class="before">Agree to the community’s
                          <a type="button" style="cursor:pointer; text-decoration: underline; -webkit-appearance: none !important;"  data-bs-toggle="modal" data-bs-target="#myModal">
                                   code of conduct</a>
                        </li>
                        <li class="before">Please fill out the following quick registration.</li>
                    </ul>
                </div>
          

            
        </div>

        <div class="image-div" fxLayout="column wrap" >

            <img class="image" src="assets/images/cinejoy/Hero-popcorn.png" alt="Cinejoy Home Page Image">

        </div>
        </div>
        <div  fxLayout="row wrap" class="button-main-div" >
            <div fxLayout="row wrap" class="button-div" fxLayoutAlign="center"  fxLayoutGap="50px">
            <button class="btn" (click)="gotoGettingStarted()" ><span class="btn_effect">Get Started</span></button>

        </div>
        </div>

        
    </div>

    <div class="footer-div" > 
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>


</div>
                            <!-- wev view ended -->

                         <!-- mobile view started -->

<div class="mobile-view" 
                            fxHide.lg 
                            fxHide.md 
                            fxHide.lt 
                            fxFlex.lt-md
                            fxShow.xs  
                            fxHide.gt-lg >

    <div class="mobile-navbar">
        <app-sidebar></app-sidebar>
    </div>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div> 

    <div class="main-div-mob" fxLayout="column wrap">
            
        <div fxLayout="column">

            <div class="image-div-mob" fxLayout="column" fxLayoutAlign="start center">

                <img class="image-mob" src="assets/images/cinejoy/Hero-popcorn.png" alt="Cinejoy Home Page Image">
        
            </div>
        
            <div fxLayout="column" class="description-div-mob" >

                <h1 class="heading-mob">Host Screening Parties</h1>

                <p class="description">
                    Welcome to Hosting a Screening Party—an easy and fun way to support and engage with Cinejoy movies, events, artists, and community.
                </p>
                    Requirements are as follows:                  
                    <div fxLayout="row wrap"  fxLayoutAlign="start center" >
                    
                        <ul >
                            <li class="before">Utilize your Zoom Meeting account for your Screening Party.</li>
                            <li class="before">Agree to invite/engage 50% of your friends and family in your meeting while opening up the remaining spots for the Cinejoy community at large.</li>
                            <li class="before"><a href="https://www.youtube.com/watch?v=Hmvr3fD2auI" target="_blank">Watch the Host training video.</a></li>
                            <li class="before"><a href="/cinejoy/screening-parties/host-guide">How-to Host guide.</a></li>
                            
                            <li class="before">Agree to the community’s
                              <a type="button" style="cursor:pointer; text-decoration: underline; -webkit-appearance: none !important;"  data-bs-toggle="modal" data-bs-target="#myModal">
                                       code of conduct</a>
                            </li>
                            <li class="before">Please fill out the following quick registration.</li>
                        </ul>
                    </div>    
                

    
    
            </div>

            <div fxLayout="row wrap" class="button-div-mob" fxLayoutGap="10px">

                <button class="mobileBtn" (click)="gotoGettingStarted()">Get Started</button>
                
                
            </div>

        </div>

    </div>


    <div class="footer-div">
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>
    
</div>

<div class="modal" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered">
      <div class="modal-content">
        
        <div class="modal-body" >
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
          <img class="modalImage" src="assets\images\screening-parties\Cinejoy Code of Conduct (1).jpg" alt="">
        </div>
       
      </div>
    </div>
  </div>